import axios from 'axios';
import { ADMIN_API_ORIGIN } from '@/config/domains';
import type {
  ExportRoomDebugLogsReply,
  ExportRoomDebugLogsRequest,
} from '@/types';
import { API_TIMEOUT } from '@/utils/constants';

const roomDebugLogsClient = axios.create({
  baseURL: `${ADMIN_API_ORIGIN}/api/desktop/v1/`,
  timeout: API_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

roomDebugLogsClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      console.error(`Room Debug Logs API Error: ${status}`, data);
    } else if (error.request) {
      console.error('Room Debug Logs API Network Error', error.request);
    } else {
      console.error('Room Debug Logs API Error', error.message);
    }

    return Promise.reject(error);
  },
);

export const roomDebugLogsApi = {
  exportLogs: async (
    roomId: string,
    data: ExportRoomDebugLogsRequest,
  ): Promise<ExportRoomDebugLogsReply> => {
    return roomDebugLogsClient.post(
      `internal/rooms/${encodeURIComponent(roomId)}/debug-logs/export`,
      data,
    );
  },
};
